import { Pipe, PipeTransform } from '@angular/core';
import { Link } from 'shared/services/links.model';


@Pipe({ name: 'getCategoryLink' })
export class GetCategoryLinkPipe implements PipeTransform {

  public transform(categoryId: string, pieceName?: string | null, country?: string, lang?: string): Link {
    return {
      type: 'category',
      pieceName,
      categoryId,
      country,
      lang
    };
  }

}
